import {
  EProfileChangesActions,
  ProfileChangesActions,
} from '@myStore/profile-changes/profile-changes.actions';
import {
  initialProfileChangesState,
  IProfileChangesState,
} from '@myStore/profile-changes/profile-changes.state';

export const profileChangesReducers = (
  state = initialProfileChangesState,
  actions: ProfileChangesActions
): IProfileChangesState => {
  switch (actions.type) {
    case EProfileChangesActions.ClearErrorsEditSelfProfile:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          isLoading: false,
          success: false,
          errors: {},
        },
      };
    case EProfileChangesActions.EditAvatarRequest:
      return {
        ...state,
        editAvatar: {
          ...state.editAvatar,
          errors: null,
          isLoading: true,
        },
      };
    case EProfileChangesActions.EditAvatarSuccess:
      return {
        ...state,
        editAvatar: {
          ...state.editAvatar,
          isLoading: false,
        },
      };
    case EProfileChangesActions.EditAvatarFailure:
      return {
        ...state,
        editAvatar: {
          ...state.editAvatar,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EProfileChangesActions.EditSelfProfileRequest:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          errors: null,
          isLoading: true,
          success: false,
        },
      };
    case EProfileChangesActions.EditSelfProfileSuccess:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          isLoading: false,
          success: true,
        },
      };
    case EProfileChangesActions.EditSelfProfileFailure:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          isLoading: false,
          errors: actions.errors,
          success: false,
        },
      };

    default:
      return state;
  }
};
